/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Overview_SubtitleInputs */

const en_ticket_overview_subtitle = /** @type {(inputs: Ticket_Overview_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your assigned service tickets`)
};

const ja_ticket_overview_subtitle = /** @type {(inputs: Ticket_Overview_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割り当てられたサービスチケット`)
};

const fr_ticket_overview_subtitle = /** @type {(inputs: Ticket_Overview_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos tickets de service assignés`)
};

const de_ticket_overview_subtitle = /** @type {(inputs: Ticket_Overview_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre zugewiesenen Service-Tickets`)
};

/**
* | output |
* | --- |
* | "Your assigned service tickets" |
*
* @param {Ticket_Overview_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_overview_subtitle = /** @type {((inputs?: Ticket_Overview_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Overview_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_overview_subtitle(inputs)
	if (locale === "ja") return ja_ticket_overview_subtitle(inputs)
	if (locale === "fr") return fr_ticket_overview_subtitle(inputs)
	return de_ticket_overview_subtitle(inputs)
});